<template>
  <div class="vh-100 d-flex justify-content-center">
    <div class="form-access my-auto">
      <form>
        <span>{{ t("resetPasswordLabel") }}</span>
        <input type="email" class="form-control" :placeholder="t('emailAddressPlaceHolder')" v-model="email" required />
        <button type="submit" class="btn btn-primary" :disabled="!submitEnabled"
          @click.prevent="resetPassword()">{{ t("resetPasswordButtonLabel") }}</button>
        <h2>
          <router-link to="/login"> {{ t("loginLabel") }}</router-link>
        </h2>
      </form>
    </div>
  </div>
</template>

<script>
import http from "@/api/http-common";
import I18n from "@/lang/i18n.js";
import HttpUtils from "@/assets/js/http_utils.js";

export default {
  data() {
    return {
      email: ""
    }
  },
  methods: {
        t(key, ...args) {
            const language = typeof this.getUserLanguage === "function" ? this.getUserLanguage() : this.getUserLanguage;
            return I18n.t(key, language, ...args);
        },
    getUserType() {
      return this.$store.getters["getUserType"];
    },    
    async resetPassword() {
      try {
        const res = await http.getApiClient(this.getUserType()).get("", {
          params: {
            a: "reset_password",
            em: encodeURIComponent(this.email)
          }
        });
        // reset email to avoid clicking on button
        this.email = "";
        if (res) {
          // check answer
          const errorCode = HttpUtils.getStatusMessage(res.data.ec, this.getUserLanguage);

          if (errorCode === "") {
            this.$toast.success(this.t("passwordResetMessage"), {
              "duration": 10000,
              "pauseOnHover": true
            });
            this.$router.push({ name: "Login" });
          } else {
            this.$toast.error(errorCode, {
              "duration": 5000,
              "pauseOnHover": true
            });
          }
        }
      } catch (e) {
        console.error(e);
      }
    }    
  },
  computed: {
    submitEnabled() {
      return this.email.length > 0;
    },
    getUserLanguage() {
      return this.$store.getters["getNonLoggedInLanguage"]?.toUpperCase() || "EN";
    }
  }
}
</script>
